import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detail-skeleton',
  templateUrl: './detail-skeleton.component.html',
  styleUrls: ['./detail-skeleton.component.css'],
})
export class DetailSkeletonComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
